import { GlobalService } from './../../shared/global.service';
import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

import { AngularFireAuth } from '@angular/fire/auth';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { User } from 'src/app/shared/models/user';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  user$: Observable<User | null>;

  constructor(private http: HttpClient,
    private router: Router,
    public afAuth: AngularFireAuth,
    private globalService: GlobalService,
    private snackBar: MatSnackBar) {
    this.user$ = this.afAuth.authState;
  }

  async loginWithEmailLink() {
    let isAuthenticated=false;
    // Confirm the link is a sign-in with email link.
    console.log('test oob')
    console.log(window.location.href);
    if (this.afAuth.auth.isSignInWithEmailLink(window.location.href)) {
      console.log('link is oob')
      // Additional state parameters can also be passed via URL.
      // This can be used to continue the user's intended action before triggering
      // the sign-in operation.
      // Get the email if available. This should be available if the user completes
      // the flow on the same device where they started it.
      var email = window.localStorage.getItem('emailForSignIn');
      if (!email) {
        // User opened the link on a different device. To prevent session fixation
        // attacks, ask the user to provide the associated email again. For example:
        email = window.prompt('Por favor, confirme seu email.');
      }
      // The client SDK will parse the code from the link for you.
      await this.afAuth.auth.signInWithEmailLink(email, window.location.href)
        .then((result) => {
          // Clear email from storage.
          window.localStorage.removeItem('emailForSignIn');
          isAuthenticated = true;
          // You can access the new user via result.user
          // Additional user info profile not available via:
          // result.additionalUserInfo.profile == null
          // You can check if the user is new or existing:
          // result.additionalUserInfo.isNewUser
        })
        .catch((error) => {
          // Some error occurred, you can inspect the code: error.code
          // Common errors could be invalid email and invalid or expired OTPs.
        });
    }

    return isAuthenticated;
    
  }

  logout() {
    this.afAuth.auth.signOut().then(() => {
      let apiKey = this.globalService.apiKey;
      this.router.navigate(['user', 'login', apiKey]);
    });
  }

  private handleError(res: HttpErrorResponse) {
    console.error(res);
    return throwError(res.error || 'Server error');
  }
}
